import React from "react";
import { Box, Typography } from "@mui/material";
import { useLanguage } from "../context/LanguageContext.js";

const SondageCardsView = ({ contacts, periodeId, isSurveyClosed, isAdmin, onUpdate }) => {
  const { t } = useLanguage();

  // 🔥 flèche scroll
  const [showArrow, setShowArrow] = React.useState(true);
  const handleScroll = (e) => {
    if (e.target.scrollLeft > 10) setShowArrow(false);
  };

    return (
      <>
      {/* 🔥 flèche au dessus */}
      {showArrow && (
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            justifyContent: "center",
            mb: 1,
            fontSize: 14,
            opacity: 0.8
          }}
        >
          ➜ {t("ScrollRight")} →
        </Box>
      )}

      {/* 🔥 conteneur scroll unique */}
      <Box
        onScroll={handleScroll}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
          overflowX: "auto",
          paddingY: 1
        }}
      >
      
      {contacts.map((c) => {
        const total = c[periodeId] ?? 0;
        const isTotalCard = c._id === "total-"; // 🔥 carte total

        return (
          <Box
            key={c._id}
            sx={{
              flexShrink: 0, 
              p: 2,
              borderRadius: 2,
              backgroundColor: isTotalCard ? "#f3eee7" : "#fff", // 🔥 couleur différente 
              border: "1px solid #ddd",
              width: { xs: "85%", sm: 180 },
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <Typography sx={{ fontWeight: "bold", fontSize: 16 }}>
              {c.nom}
            </Typography>


            {/*{!isTotalCard && (
            <Typography sx={{ mt: 0.5, fontSize: 14 }}>
              {t("HowManyPeople")} : <strong>{c.combien ?? 1}</strong>
            </Typography>
            )}*/}


            <Typography sx={{ mt: 1, fontSize: 14 }}>
              {isTotalCard ? t("Total") : t("Participants")} : <strong>{total}</strong>
            </Typography>

            {!isTotalCard && !isSurveyClosed && (
              <Box
                sx={{
                  mt: 1,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <button onClick={() => onUpdate(c, periodeId, total + 1)}>+</button>
                <button onClick={() => onUpdate(c, periodeId, Math.max(0, total - 1))}>-</button>
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
    </>
  );
};

export default SondageCardsView;
